import React from "react";
import { CollapseFAQ, H1, H2, NamedLink } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';

import ContinueIcon from '../../TopbarContainer/Topbar/images/continue-icon.svg';

import css from '../PetSittingServicesPage.module.css';
import { petSittingFaq } from "./faqs";
import TrustWidgetSmall from "../../../components/StaticPageContainers/TrustWidgetSmall";
import TrustWidgetBig from "../../../components/StaticPageContainers/TrustWidgetBig";


const TrustedServicesPage = props => {
    return (
        <div className={css.rootOld}>
            {/* Hero Section */}
            <H1 className={css.mainTitle}>
                <FormattedMessage id="PetSittingServicesPage.mainTitle" />
            </H1>

            <p className={css.info}>
                <FormattedMessage id="PetSittingServicesPage.mainSubtitle" />
            </p>

            <div className={css.buttonsContainer}>
                <NamedLink
                    className={css.ctaButton}
                    name="SearchHouseSitterPage"
                >
                    <FormattedMessage id="PetSittingServicesPage.findPetsitter" />
                    <img src={ContinueIcon} className={css.icon} />
                </NamedLink>
                <NamedLink
                    className={css.ctaButton}
                    name="SearchHouseSitPage"
                >
                    <FormattedMessage id="PetSittingServicesPage.findPetSittingOpportunities" />
                    <img src={ContinueIcon} className={css.icon} />
                </NamedLink>
            </div>

            <TrustWidgetSmall text={<FormattedMessage id="PetSittingServicesPage.trustpilotNote" />} />

            {/* Why Choose HouseSit Match Section */}
            <H2 className={css.sectionTitle}>
                <FormattedMessage id="PetSittingServicesPage.whyChooseTitle" />
            </H2>

            <p className={css.info}>
                <FormattedMessage id="PetSittingServicesPage.whyChooseSubtitle" />
            </p>

            <div className={css.benefitsGrid}>
                <div className={css.benefitCard}>
                    <p className={css.benefitTitle}>
                        <FormattedMessage id="PetSittingServicesPage.benefit1Title" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.benefit1Text" />
                    </p>
                </div>

                <div className={css.benefitCard}>
                    <p className={css.benefitTitle}>
                        <FormattedMessage id="PetSittingServicesPage.benefit2Title" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.benefit2Text" />
                    </p>
                </div>

                <div className={css.benefitCard}>
                    <p className={css.benefitTitle}>
                        <FormattedMessage id="PetSittingServicesPage.benefit3Title" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.benefit3Text" />
                    </p>
                </div>

                <div className={css.benefitCard}>
                    <p className={css.benefitTitle}>
                        <FormattedMessage id="PetSittingServicesPage.benefit4Title" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.benefit4Text" />
                    </p>
                </div>

                <div className={css.benefitCard}>
                    <p className={css.benefitTitle}>
                        <FormattedMessage id="PetSittingServicesPage.benefit5Title" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.benefit5Text" />
                    </p>
                </div>
            </div>

            <div className={css.ctaContainer}>
                <NamedLink
                    className={css.ctaButton}
                    name="SignupPage"
                >
                    <FormattedMessage id="PetSittingServicesPage.listYourRequest" />
                    <img src={ContinueIcon} className={css.icon} />
                </NamedLink>
                <p className={css.smallLink}>
                    <FormattedMessage id="PetSittingServicesPage.lookingToPetSit" />{' '}
                    <NamedLink name="SearchHouseSitPage">
                        <FormattedMessage id="PetSittingServicesPage.seeCurrentHouseSits" />
                    </NamedLink>
                </p>
            </div>

            {/* Pet Types We Cover Section */}
            <H2 className={css.sectionTitle}>
                <FormattedMessage id="PetSittingServicesPage.petTypesTitle" />
            </H2>

            <p className={css.info}>
                <FormattedMessage id="PetSittingServicesPage.petTypesSubtitle" />
            </p>

            <div className={css.petTypesGrid}>
                <div className={css.petTypeCard}>
                    <p className={css.petTypeName}>
                        <FormattedMessage id="PetSittingServicesPage.dogSittingTitle" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.dogSittingText" />
                    </p>
                    <NamedLink
                        name="PetSittingServicesPage"
                        params={{ serviceType: 'dog-sitting' }}
                        className={css.learnMoreLink}
                    >
                        <FormattedMessage id="PetSittingServicesPage.learnMore" />
                    </NamedLink>
                </div>

                <div className={css.petTypeCard}>
                    <p className={css.petTypeName}>
                        <FormattedMessage id="PetSittingServicesPage.catSittingTitle" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.catSittingText" />
                    </p>
                    <NamedLink
                        name="PetSittingServicesPage"
                        params={{ serviceType: 'cat-sitting' }}
                        className={css.learnMoreLink}
                    >
                        <FormattedMessage id="PetSittingServicesPage.learnMore" />
                    </NamedLink>
                </div>

                <div className={css.petTypeCard}>
                    <p className={css.petTypeName}>
                        <FormattedMessage id="PetSittingServicesPage.rabbitSittingTitle" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.rabbitSittingText" />
                    </p>
                    <NamedLink
                        name="PetSittingServicesPage"
                        params={{ serviceType: 'rabbit-sitting' }}
                        className={css.learnMoreLink}
                    >
                        <FormattedMessage id="PetSittingServicesPage.learnMore" />
                    </NamedLink>
                </div>

                <div className={css.petTypeCard}>
                    <p className={css.petTypeName}>
                        <FormattedMessage id="PetSittingServicesPage.birdSittingTitle" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.birdSittingText" />
                    </p>
                    <NamedLink
                        name="PetSittingServicesPage"
                        params={{ serviceType: 'bird-sitting' }}
                        className={css.learnMoreLink}
                    >
                        <FormattedMessage id="PetSittingServicesPage.learnMore" />
                    </NamedLink>
                </div>

                <div className={css.petTypeCard}>
                    <p className={css.petTypeName}>
                        <FormattedMessage id="PetSittingServicesPage.guineaPigSittingTitle" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.guineaPigSittingText" />
                    </p>
                </div>

                <div className={css.petTypeCard}>
                    <p className={css.petTypeName}>
                        <FormattedMessage id="PetSittingServicesPage.otherPetsTitle" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.otherPetsText" />
                    </p>
                </div>
            </div>

            {/* How Pet Sitting Works Section */}
            <H2 className={css.sectionTitle}>
                <FormattedMessage id="PetSittingServicesPage.howItWorksTitle" />
            </H2>

            <p className={css.info}>
                <FormattedMessage id="PetSittingServicesPage.howItWorksSubtitle" />
            </p>

            <div className={css.stepsContainer}>
                <div className={css.step}>
                    <div className={css.stepNumber}>1</div>
                    <p className={css.stepTitle}>
                        <FormattedMessage id="PetSittingServicesPage.step1Title" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.step1Text" />
                    </p>
                </div>

                <div className={css.step}>
                    <div className={css.stepNumber}>2</div>
                    <p className={css.stepTitle}>
                        <FormattedMessage id="PetSittingServicesPage.step2Title" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.step2Text" />
                    </p>
                </div>

                <div className={css.step}>
                    <div className={css.stepNumber}>3</div>
                    <p className={css.stepTitle}>
                        <FormattedMessage id="PetSittingServicesPage.step3Title" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.step3Text" />
                    </p>
                </div>

                <div className={css.step}>
                    <div className={css.stepNumber}>4</div>
                    <p className={css.stepTitle}>
                        <FormattedMessage id="PetSittingServicesPage.step4Title" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.step4Text" />
                    </p>
                </div>
            </div>

            <div className={css.ctaContainer}>
                <NamedLink
                    className={css.ctaButton}
                    name="SearchHouseSitterPage"
                >
                    <FormattedMessage id="PetSittingServicesPage.findPetsitter" />
                    <img src={ContinueIcon} className={css.icon} />
                </NamedLink>
                <p className={css.smallLink}>
                    <FormattedMessage id="PetSittingServicesPage.newToPetSitting" />{' '}
                    <NamedLink name="WhatIsHouseSittingPage">
                        <FormattedMessage id="PetSittingServicesPage.howHouseSittingWorks" />
                    </NamedLink>
                </p>
            </div>

            {/* What Pet Owners Say Section */}
            <H2 className={css.sectionTitle}>
                <FormattedMessage id="PetSittingServicesPage.testimonialsTitle" />
            </H2>

            <p className={css.info}>
                <FormattedMessage id="PetSittingServicesPage.testimonialsSubtitle" />
            </p>

            <div className={css.testimonialsGrid}>
                <div className={css.testimonialCard}>
                    <p className={css.testimonialText}>
                        "<FormattedMessage id="PetSittingServicesPage.testimonial1Text" />"
                    </p>
                    <p className={css.testimonialAuthor}>
                        <FormattedMessage id="PetSittingServicesPage.testimonial1Author" />
                    </p>
                </div>

                <div className={css.testimonialCard}>
                    <p className={css.testimonialText}>
                        "<FormattedMessage id="PetSittingServicesPage.testimonial2Text" />"
                    </p>
                    <p className={css.testimonialAuthor}>
                        <FormattedMessage id="PetSittingServicesPage.testimonial2Author" />
                    </p>
                </div>

                <div className={css.testimonialCard}>
                    <p className={css.testimonialText}>
                        "<FormattedMessage id="PetSittingServicesPage.testimonial3Text" />"
                    </p>
                    <p className={css.testimonialAuthor}>
                        <FormattedMessage id="PetSittingServicesPage.testimonial3Author" />
                    </p>
                </div>
            </div>

            <p className={css.ratingsNote}>
                <FormattedMessage id="PetSittingServicesPage.ratingsNote" />
            </p>

            {/* <p className={css.smallLink}>
                <a href="https://uk.trustpilot.com/review/housesitmatch.com" target="_blank" rel="noopener noreferrer">
                    <FormattedMessage id="PetSittingServicesPage.readMoreReviews" />
                </a>
            </p> */}
            <TrustWidgetBig />

            {/* Support & Welfare Section */}
            <H2 className={css.sectionTitle}>
                <FormattedMessage id="PetSittingServicesPage.supportTitle" />
            </H2>

            <p className={css.info}>
                <FormattedMessage id="PetSittingServicesPage.supportSubtitle" />
            </p>

            <div className={css.supportGrid}>
                <div className={css.supportCard}>
                    <p className={css.supportCardTitle}>
                        <FormattedMessage id="PetSittingServicesPage.charityPartnersTitle" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.charityPartnersText" />
                    </p>
                </div>

                <div className={css.supportCard}>
                    <p className={css.supportCardTitle}>
                        <FormattedMessage id="PetSittingServicesPage.vetAdviceTitle" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.vetAdviceText" />
                    </p>
                </div>
            </div>

            {/* Tips for Booking Section */}
            <H2 className={css.sectionTitle}>
                <FormattedMessage id="PetSittingServicesPage.tipsTitle" />
            </H2>

            <p className={css.info}>
                <FormattedMessage id="PetSittingServicesPage.tipsSubtitle" />
            </p>

            <div className={css.tipsGrid}>
                <div className={css.tipCard}>
                    <p className={css.tipTitle}>
                        <FormattedMessage id="PetSittingServicesPage.tip1Title" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.tip1Text" />
                    </p>
                </div>

                <div className={css.tipCard}>
                    <p className={css.tipTitle}>
                        <FormattedMessage id="PetSittingServicesPage.tip2Title" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.tip2Text" />
                    </p>
                </div>

                <div className={css.tipCard}>
                    <p className={css.tipTitle}>
                        <FormattedMessage id="PetSittingServicesPage.tip3Title" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.tip3Text" />
                    </p>
                </div>

                <div className={css.tipCard}>
                    <p className={css.tipTitle}>
                        <FormattedMessage id="PetSittingServicesPage.tip4Title" />
                    </p>
                    <p className={css.info}>
                        <FormattedMessage id="PetSittingServicesPage.tip4Text" />
                    </p>
                </div>
            </div>

            <div className={css.ctaContainer}>
                <NamedLink
                    className={css.ctaButton}
                    name="MembershipPlansPage"
                    params={{ accountType: 'homeowner' }}
                >
                    <FormattedMessage id="PetSittingServicesPage.comparePlans" />
                    <img src={ContinueIcon} className={css.icon} />
                </NamedLink>
                <p className={css.smallLink}>
                    <FormattedMessage id="PetSittingServicesPage.preferToBrowse" />{' '}
                    <NamedLink name="SearchHouseSitterPage">
                        <FormattedMessage id="PetSittingServicesPage.findPetsitterLink" />
                    </NamedLink>
                </p>
            </div>

            {/* Join the Community Section */}
            <H2 className={css.sectionTitle}>
                <FormattedMessage id="PetSittingServicesPage.communityTitle" />
            </H2>

            <p className={css.info}>
                <FormattedMessage id="PetSittingServicesPage.communityText" />
            </p>

            <div className={css.ctaContainer}>
                <NamedLink
                    className={css.ctaButton}
                    name="SignupPage"
                >
                    <FormattedMessage id="PetSittingServicesPage.createFreeAccount" />
                    <img src={ContinueIcon} className={css.icon} />
                </NamedLink>
                <p className={css.smallLink}>
                    <FormattedMessage id="PetSittingServicesPage.areYouSitter" />{' '}
                    <NamedLink name="MembershipPlansPage" params={{ accountType: 'housesitter' }}>
                        <FormattedMessage id="PetSittingServicesPage.seeSitterPlans" />
                    </NamedLink>
                </p>
            </div>

            {/* FAQs Section */}
            <H2 className={css.sectionTitle}>
                <FormattedMessage id="PetSittingServicesPage.faqTitle" />
            </H2>

            <CollapseFAQ
                list={petSittingFaq}
            />
        </div>
    )
};

export default TrustedServicesPage;
